import * as React from "react";
import type { SVGProps } from "react";
const SvgReliability = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M31.792 2.081c.548 0 .992.445.992.993v56.86h5.557v-5.943a.992.992 0 0 1 1.985 0v6.936a.992.992 0 0 1-.993.992h-7.541a.992.992 0 0 1-.993-.992V3.074c0-.548.445-.993.993-.993Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M63.008 31.376c0-12.414-13.88-22.476-31.007-22.476C14.874 8.9.994 18.962.994 31.376h62.014Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M9.492 14.68c5.798-4.204 13.76-6.772 22.509-6.772 8.75 0 16.71 2.568 22.508 6.771C60.306 18.881 64 24.772 64 31.376v.992H.001v-.992c0-6.604 3.694-12.495 9.491-16.697ZM2.018 30.383h59.966c-.347-5.425-3.525-10.39-8.64-14.098-5.423-3.931-12.966-6.394-21.343-6.394s-15.92 2.463-21.344 6.394c-5.115 3.708-8.292 8.673-8.64 14.098Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgReliability;
